/* eslint-disable prettier/prettier */
import { IDiscoverDetailsValues, IDiscoverNode } from '../../../Interfaces/discover.interfaces';
import { isEmpty } from '../../../helpers/isEmpty';
const payloadAssembler = (values: IDiscoverDetailsValues) => {
    const { cardBackground, cardImageURL, headerName, index, isNameHidden, isSmallSize, name, type, ...remainingValues } = values;
    let payload: IDiscoverNode = {
        name,
        isNameHidden,
        isSmallSize,
        cardBackground,
        headerName,
        index,
        cardImageURL,
        content: {
            type,
        },
    };

    switch (
        type //Let's filter out irrelevant content based on the content type that is currently selected!
    ) {
        case 'link':
            const {
               ads,
                adUrls
            } = remainingValues;
            payload.isAd = remainingValues.isAd;
            payload.content.url = remainingValues.url ? remainingValues.url : null;
            if (!isEmpty(ads)) payload.content.ads = ads;
            //Grab ad urls, if they exist
            if(!isEmpty(adUrls)){
                //If url map is not empty, go ahead and bind to appropriate ad
                payload.content.ads.uploaded.map((ad:any) =>{
                    ad.adUrl = adUrls[ad.id] ? adUrls[ad.id] : ad.adUrl;
                })
            }

            //If ad, we should remove content.url from
            break;
        case 'webview':
            payload.content.url = remainingValues.url;
            break;
        case 'list':
            payload.content.isSearchable = remainingValues.isSearchable ? remainingValues.isSearchable : null;
            break;
        case 'scrollableText':
            payload.content.scrollableText = remainingValues.scrollableText;
            break;
        case 'html':
            let strippedCSS = remainingValues.css ? remainingValues.css.replace(/\s+/g, '') : '';
            payload.content.html = remainingValues.html;
            payload.content.css = strippedCSS;
            break;

        case 'map':
            payload.content.address = remainingValues.address;
            break;

        case 'canvas':
            payload.content.sitePageId = remainingValues.sitePageId;
            break;

        case 'zoomImage':
            payload.content.imageURL = remainingValues.imageURL;
            break;
        case 'info':
            const {
                additionalInformation,
                contactName,
                description,
                documents,
                email,
                facebookURL,
                imageURL,
                linkedInURL,
                phoneNumber,
                twitterURL,
                url,
            } = remainingValues;
            if (!isEmpty(description)) payload.content.description = description;
            if (!isEmpty(contactName)) payload.content.contactName = contactName;
            if (!isEmpty(additionalInformation)) payload.content.additionalInformation = additionalInformation;
            if (!isEmpty(email)) payload.content.email = email;
            if (!isEmpty(facebookURL)) payload.content.facebookURL = facebookURL;
            if (!isEmpty(imageURL)) payload.content.imageURL = imageURL;
            if (!isEmpty(phoneNumber)) payload.content.phoneNumber = phoneNumber;
            if (!isEmpty(twitterURL)) payload.content.twitterURL = twitterURL;
            if (!isEmpty(linkedInURL)) payload.content.linkedInURL = linkedInURL;
            if (!isEmpty(imageURL)) payload.content.imageURL = imageURL;
            if (!isEmpty(documents)) payload.content.documents = documents;
            if (!isEmpty(url)) payload.content.url = url;
            break;
    }
    return payload;
};
export default payloadAssembler;
